import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { validateConfirmationCode } from "../../authSlice";
import BlockUI from "../../../../base/components/BlockUI";

import "./modal.scss";

function Popup({ show, setShow }) {
   const { isLoading } = useSelector((state) => state.auth);

   const dispatch = useDispatch();
   const navigate = useNavigate();
   const [code, setCode] = useState("");

   const sentCode = () => {
      if (!code) {
         return;
      }
      dispatch(validateConfirmationCode(code, successCallback));
   };

   const successCallback = () => {
      navigate("/auth/register-organization", { state: { fromApp: true } });
   };

   return (
      <>
         <Modal
            className="register-popup"
            show={show}
            backdrop={"static"}
            keyboard={false}
            centered
         >
         <BlockUI isLoading={isLoading} />
            
            <div className="text-part">
               <h5>
                  Please check email for <br /> verification code
               </h5>
            </div>
            <div className="code-part">
               <p>Enter code</p>
               <input
                  maxLength={12}
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  className="code-area"
               />
            </div>
            <div className="btn-area">
               <button onClick={sentCode} className="btn-outline">
                  Done
               </button>
            </div>
         </Modal>
      </>
   );
}

export default Popup;
